import Button from "../ui/Button"

export default function DashboardHeader({
  title = "Dashboard",
  buttons = ["Ongoing studies", "Created studies", "Managed studies", "Closed studies"],
  activeButton = "Ongoing studies",
  onButtonClick = () => {},
}) {


  const handleButtonClick = (buttonName) => {
    onButtonClick(buttonName)
  }

  return (
    <div className="bg-dashboard-bg flex flex-col gap-3 py-4 px-4 sm:flex-row sm:items-center sm:justify-between sm:py-6 sm:px-6">
      {/* Title (truncate long names instead of pushing layout) */}
      <h1 className="min-w-0 text-xl font-semibold text-gray-900 sm:shrink-0">
        <span className="block truncate">{title}</span>
      </h1>
  
      {/* Buttons bar: horizontal scroll on small screens, no overflow */}
      <div
        className="bg-white rounded-xl p-1 overflow-x-auto whitespace-nowrap"
        aria-label="Study sections"
      >
        <div className="flex flex-nowrap gap-2">
          {buttons.map((buttonName) => {
            const isActive = activeButton === buttonName
            return (
              <Button
                key={buttonName}
                variant="dashboardHeader"
                size="sm"
                isActive={isActive}
                onClick={() => handleButtonClick(buttonName)}
                className="shrink-0 px-4 py-1.5 text-sm font-medium"
              >
                {buttonName}
              </Button>
            )
          })}
        </div>
      </div>
    </div>
  )
  }

